import {Button} from 'antd'
import http from '@/biz/http.mjs'
import runAsync from '@/script/runAsync.mjs'
import openWindow from '@/script/openWindow.mjs'
import {useMapContext} from '@/components/MindMap/index.mjs'

export default function PropertiesPaneButtonDiff(props) {
    const map = useMapContext()
    const selectedNodes = map.useSelectedNodes()

    if (1 !== selectedNodes.size) {
        return null
    }

    const [req] = selectedNodes
    const {moduleType, pkid, reqType} = req.data

    if (! (pkid && 'UPT' === reqType)) {
        return null
    }

    const [bas, tar] = (() => {
        const nodes = []

        for (const n of req.children) {
            const {bizNodeType} = n.data

            if ('ISRFREQ_BASMODULE' === bizNodeType) {
                nodes[0] = n.firstChild
            }
            else if ('ISRFREQ_TARMODULE' === bizNodeType) {
                nodes[1] = n.firstChild
            }
        }

        return nodes
    })()

    if (! (bas && tar)) {
        return null
    }

    const {bizNodeType: tBas, pkid: basDppId} = bas.data
    const {bizNodeType: tTar, pkid: tarDppId} = tar.data

    if (tBas !== tTar) {
        return null
    }

    const handleClick = async e => {
        const readSnapshotId = async node => {
            const {bizNodeType, mapVerId, pkid, rev} = node.data

            if (mapVerId) {
                return mapVerId
            }

            const {pkid: id} = await http.get(
                '/basmapvers/verid',
                {bizNodeType, pkid, rev}
            )

            return id
        }

        const [basMapVerId, tarMapVerId] = await runAsync(
            () => Promise.all([
                readSnapshotId(bas),
                readSnapshotId(tar),
            ]),

            {action: '读取发布版本'}
        )

        const args = {basMapVerId, tarMapVerId, type: moduleType}
        const {classes} = map.BizNode[tBas]

        if (classes.includes('component')) {
            Object.assign(args, {basDppId, tarDppId})
        }

        openWindow('/DiffMap', args, e.target)
    }

    return (
        <Button
            onClick={handleClick}
            {...props}
        >
            模件比对
        </Button>
    )
}
